import React, { Component } from "react";
import PropTypes from "prop-types";
import SubjectGroup from "./SubjectGroup";
import ReactBricks from "react-bricks-infinite";

export default class CurriculumBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reRender: false
    };

    window.onresize = () => {
      console.log("Trigger a Resize");

      this.setState({ reRender: true });
    };

    this.buildGroups = this.buildGroups.bind(this);
  }

  buildGroups() {
    let groups = [];
    const { curriculumData } = this.props;
    curriculumData.forEach(element => {
      const group = {
        subjectId: element.subjectId,
        subjectName: element.subjectName
      };
      const index = groups.findIndex(
        g =>
          g.subjectId === group.subjectId && g.subjectName === group.subjectName
      );
      if (index === -1) {
        group.items = [element];
        groups.push(group);
      } else {
        groups[index].items.push(element);
      }
    });
    return groups;
  }

  render() {
    const groups = this.buildGroups();

    const sizes = [
      { columns: 1, gutter: 0 },
      { mq: "992px", columns: 2, gutter: 5 }
    ];

    return (
      <ReactBricks
        sizes={sizes}
        style={{ width: "100%" }}
        reRender={this.state.reRender}
        bricks={groups.map((g, i) => (
          <SubjectGroup key={i} {...g} />
        ))}
      />
    );
  }
}

CurriculumBlock.propTypes = {
  curriculumData: PropTypes.array.isRequired
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/CurriculumBlock/CurriculumBlock.js